/* Shahan Hero Slider */
(function () {
  document.querySelectorAll('[data-shahan-hero-slider]').forEach(function (root) {
    var slides = root.querySelectorAll('.shahan-hero-slide');
    var dots = root.querySelectorAll('.shahan-hero-slider__dot');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var total = slides.length;
    var index = 0;
    var timer = null;

    if (total <= 1) return;

    var autoplay = root.dataset.autoplay !== 'false';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var hovering = false;

    function show(i) {
      index = (i + total) % total;
      slides.forEach(function (slide, si) {
        slide.classList.toggle('is-active', si === index);
      });
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function startAutoplay() {
      if (!autoplay || hovering) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.slideTo, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', function () { hovering = true; stopAutoplay(); });
    root.addEventListener('mouseleave', function () { hovering = false; startAutoplay(); });

    startAutoplay();
  });
})();
